import { Component, Input, OnInit } from '@angular/core';
import { isNil, round } from 'lodash';
import { CurrentSchoolYear } from '../../../../shared/constants/current-school-year.constant';
import { IStudent } from '../../../../shared/typings/interfaces/student.interface';
import { IAssementHistory, IStudentStateExam } from '../student-academic.interface';

@Component({
  selector: 'academic-panel-state-exam',
  template: require('./academic-panel-state-exam.component.html'),
})
export class AcademicPanelStateExam implements OnInit {
  @Input() student: IStudent;

  panelTitle: string;
  stateExams: Array<Array<string | IStudentStateExam>>;

  readonly NULL_CONTENT = '<span class="disabled">—</span>';
  readonly CURRENT_YEAR_FORMAT = 'This year';

  ngOnInit(): void {
    this.stateExams = this.getStateExam(this.student);
  }

  getStateExam(student: IStudent): Array<Array<string | IStudentStateExam>> {
    const filteredHistory = this.getHistory('State Assessment', student.assmnts.history);

    const stateExams = filteredHistory.reduce((map, val) => {
      const year: string = val.year.toUpperCase();
      const keyPrefix = val.subj.toLowerCase();
      const prVal = isNil(val.pr) || val.pr === 0 ? this.NULL_CONTENT : val.pr;
      const growthVal = this.getFormattedGrowth(val.growth);

      if (map.has(year)) {
        const mapVal = map.get(year);
        mapVal[keyPrefix + 'Pr'] = prVal;
        mapVal[keyPrefix + 'Growth'] = growthVal;
      } else {
        const mapObj: IStudentStateExam = {
          elaPr: this.NULL_CONTENT,
          elaGrowth: this.NULL_CONTENT,
          mathPr: this.NULL_CONTENT,
          mathGrowth: this.NULL_CONTENT,
        };
        mapObj[keyPrefix + 'Pr'] = prVal;
        mapObj[keyPrefix + 'Growth'] = growthVal;
        map.set(year, mapObj);
      }
      return map;
    }, new Map());

    const filteredStateExams = this.filterAndSortExamMap(stateExams);
    return Array.from(filteredStateExams);
  }

  filterAndSortExamMap(stateExam: Map<string, IStudentStateExam>): Map<string, IStudentStateExam> {
    let yearKeys = Array.from(stateExam.keys());
    yearKeys = yearKeys
      .sort()
      .reverse()
      .slice(0, 5);

    const sortedMap = new Map();
    yearKeys.forEach((year, index) => {
      const val = stateExam.get(year);
      if (index === 0) {
        year = this.getFormattedYear(year);
      }
      sortedMap.set(year, val);
    });

    return sortedMap;
  }

  getHistory(name: string, studentHistory: any): IAssementHistory[] {
    return studentHistory.filter(val => val.name === name);
  }

  getFormattedYear(year: string): string {
    const schoolYearEnd = year.split('-')[1];
    if (schoolYearEnd === CurrentSchoolYear.END) return this.CURRENT_YEAR_FORMAT;
    return year;
  }

  getFormattedGrowth(growth: number): string {
    if (isNil(growth) || growth === 0) return this.NULL_CONTENT;

    const prefix = growth > 0 ? '+' : '';
    return prefix + round(growth * 100, 0) + '%';
  }
}
